import axios from 'axios';

export const GET_PAYPAL_REQUESTS = '/paypalPayments/getList';
export const GET_PAYPAL_REQUESTS_EXCEL = '/paypalPayments/getListForExcel';

export function getPaypalRequests(queryParams, cancellationHandlers) {
  return axios.get(GET_PAYPAL_REQUESTS, {params: queryParams, ...cancellationHandlers});
}

export function getPaypalRequestsForExcelFile(queryParams) {
  return axios.get(GET_PAYPAL_REQUESTS_EXCEL, {params: queryParams});
}